import { IConversationData } from '../../interfaces/conversations.interfaces';

export interface ChatState {
  conversations: IConversationData[];
  selectedConversationId: string | null;
  loading: boolean;
  error: string | null;
}

export const initialState: ChatState = {
  conversations: [],
  selectedConversationId: null,
  loading: false,
  error: null
};
